import React from 'react';
import "../../css/Contact/Contact.css"


const ContactRight = (props) => {
    
    return (
        <div id='Contact_ContactRight'>
            <img id="Contact_ContactRight_img" src="/images/Home/Homepage1.jpg" alt="Home" />
        </div>
    )
}

export default ContactRight;